/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.18.0
 * @since 1.17.0
 */

import {
    EAutoReportIdFormatField as F,
    EPageAutoReportIdType,
    IAutoReportIdFormatFields,
    TAutoReportIdGetMetaSuccessPayload,
} from './types';

export interface IAutoReportIdMetaResponse {
    reportName: string;
    orderAttrType: EPageAutoReportIdType;
}

export const mapAutoReportIdMeta = (response: IAutoReportIdMetaResponse): TAutoReportIdGetMetaSuccessPayload => ({
    name: response.reportName,
    type: response.orderAttrType,
});

export const mapAutoReportIdFormatDataToRequest = (data: IAutoReportIdFormatFields) => ({
    [F.ReportFormat]: data[F.ReportFormat],
    [F.NotifyByPhoneEnabled]: data[F.NotifyByPhoneEnabled],
    ...(data[F.NotifyByPhoneEnabled] ? { [F.NotifyByPhone]: data[F.NotifyByPhone] } : {}),
    [F.NotifyByEmailEnabled]: data[F.NotifyByEmailEnabled],
    ...(data[F.NotifyByEmailEnabled] ? { [F.NotifyByEmail]: data[F.NotifyByEmail] } : {}),
    [F.SendByEmailEnabled]: data[F.SendByEmailEnabled],
    ...(data[F.SendByEmailEnabled] ? { [F.SendByEmail]: data[F.SendByEmail] } : {}),
    [F.SendByEmailZip]: data[F.SendByEmailZip],
    [F.SendByEmailZipPasswordEnabled]: data[F.SendByEmailZipPasswordEnabled],
    ...(data[F.SendByEmailZipPasswordEnabled]
        ? { [F.SendByEmailZipPassword]: data[F.SendByEmailZipPassword] } : {}),
});
